<template>
    <!--   </v-container>-->
    <v-sheet style="background-color:#fff;height:100%">
        <v-card elevation="0">
            <v-card-title>
            Cotação Mensal das Plataformas
            </v-card-title>
             <v-card-subtitle>
                 Atualize o valor das cotações.
             </v-card-subtitle>
            <v-data-table
            :footer-props="{itemsPerPageOptions:[50,100,200]}"
            :headers="headers"
            :items="items"           
            >

                <template v-slot:item.actions="{ item }">
                    <v-btn icon text :to="{name:'cotacaomensal_edit',params:{partner:item.s_partner,partner_service:item.s_partner_company}}">
                        &nbsp;<v-icon small class="mr-2" outline>launch</v-icon>
                    </v-btn>
                </template>
                
            </v-data-table>
        </v-card>
    </v-sheet>
</template>

<script>
import CotacaoService from "../../../../app/rest/cotacao"

var cotacaoService = null;

export default {
    components:{ },
    data: () => ({
        search: '',
        items:[],
        headers: [
          {
            text: 'Plataforma',
            align: 'left',
            sortable: false,
            value: 's_partner',
          },      
          { text: 'Serviço', value: 's_partner_company' },          
          { text:'Ações', value:'actions'}
        ],
    }),
    beforeCreate:function(){
        this.$store.dispatch('loading')
        cotacaoService = CotacaoService.build();
        cotacaoService.get_all().then( e =>{
            if(e.status=="ok"){
              this.items = e.items.platforms;
            }

        }).catch( e =>{
            
        }).finally( () =>{
             this.$store.dispatch('loading', false)
        });
    },
    methods:{
       
    }
};
</script>